import React from 'react';
import type { ComponentFieldDefinition } from '@troia-v3/types';
import { DynamicFieldRenderer } from '../DynamicFieldRenderer';

interface PanelGlobalGroupProps {
  group: string;
  fields: ComponentFieldDefinition[];
  values: Record<string, unknown>;
  onChange: (name: string, value: unknown) => void;
}

/** Formulário de um grupo da Configuração Global (flat — groupLabel evita FormSections internas). */
export const PanelGlobalGroup: React.FC<PanelGlobalGroupProps> = ({ group, fields, values, onChange }) => (
  <DynamicFieldRenderer fields={fields} values={values} onChange={onChange} groupLabel={group} />
);
